import { Mark, getDiffMessageClass } from "./DiffMark";
import { DiffMessageContainer, IconContainer } from "./styled";

import React from "react";
import { AdviceDiffType } from "./utils";

export const DiffMessage = ({
  diffType,
  message,
}: {
  diffType: AdviceDiffType;
  message: string;
}): React.ReactElement => {
  return (
    <DiffMessageContainer className={getDiffMessageClass(diffType)}>
      <IconContainer>
        <Mark diffType={diffType} />
      </IconContainer>
      <p>{message}</p>
    </DiffMessageContainer>
  );
};
